import styled from 'styled-components';

export const StyledPagination = styled.div`
  width: 100%;

  font-size: ${({ theme }) => theme.fontSizes.m};

  @media only screen and (max-width: ${({ theme }) => theme.breakpoints[3]}) {
    font-size: ${({ theme }) => theme.fontSizes.s};
  }

  @media only screen and (max-width: ${({ theme }) => theme.breakpoints[4]}) {
    font-size: ${({ theme }) => theme.fontSizes.m};
  }

  & article {
    flex-basis: 25%;

    @media only screen and (max-width: ${({ theme }) => theme.breakpoints[0]}) {
      flex-basis: 33.333333%;
    }

    @media only screen and (max-width: ${({ theme }) => theme.breakpoints[2]}) {
      flex-basis: 50%;
    }

    @media only screen and (max-width: ${({ theme }) => theme.breakpoints[4]}) {
      flex-basis: 100%;
    }
  }

  .pagination-button-wrapper {
    display: ${({ isLoadMoreHidden }) => isLoadMoreHidden ? 'none' : 'flex'};
    justify-content: center;
    padding-top: 20px;
    border-top: 1px solid ${({ theme }) => theme.colors.gray};

    & > button {
      &:focus {
        outline: none;
      }
  
      &:hover {
        color: ${({ theme }) => theme.colors.tycoonMain};
      }
  
      border: none;
      background-color: transparent;
      cursor: pointer;
      font-size: ${({ theme }) => theme.fontSizes.xl};
      font-weight: ${({ theme }) => theme.fontWeights[5]};
    }
  }
`;